import React from "react";
import { Modal } from "react-rainbow-components";
import { IPets } from "../../../interfaces/pets";
import ComponentListModal from "../ComponentListModal";
interface IProps {
  isOpen: boolean;
  setIsOpen(value: boolean): void;
  data: IPets[];
  onRequestClose?: () => void;
}
export default function ModalPets(props: IProps) {
  return (
    <Modal
      hideCloseButton
      style={{ overflow: "visible" }}
      isOpen={props.isOpen}
      onRequestClose={() => props.setIsOpen(false)}
    >
      {props.data && props.data.length > 0 ? (
        props.data.map((item, key) => (
          <ComponentListModal key={key} {...item} />
        ))
      ) : (
        <p style={{ margin: 0, color: "#BBB", textAlign: "center" }}>
          ผู้ใช้งานยังไม่เพิ่มสัตว์เลี้ยง
        </p>
      )}
    </Modal>
  );
}
